module.exports = __webpack_public_path__ + "static/media/a.6840dd25.jpeg";